jQuery(document).ready(function ($) {
  // Funzione per avviare il contatore
  function startCounter(element) {
    var $element = $(element);
    jQuery({ Counter: 0 }).animate(
      { Counter: $element.attr("data-stop") },
      {
        duration: 1000,
        easing: "swing",
        step: function (now) {
          $element.text("+" + Math.ceil(now));
        },
      }
    );
  }

  // counter funzioni trigger
  $(".countup").each(function () {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this);
  });
});
